import { useEffect, useState } from "react"
import { MarketplaceWork } from "data/marketplaceWorks"
import { fetchErc721TokenChainData } from "utils/erc721Owner"

interface MarketplaceWorkChainData {
  ownerAddress?: string
  tokenURI?: string
  soldCount: number
  totalCount: number
  loading: boolean
  error: boolean
}

const getFallbackState = (): MarketplaceWorkChainData => ({
  ownerAddress: undefined,
  tokenURI: undefined,
  soldCount: 1,
  totalCount: 1,
  loading: false,
  error: false,
})

const useMarketplaceWorkChainData = (work: MarketplaceWork) => {
  const [state, setState] = useState<MarketplaceWorkChainData>(() => ({
    ...getFallbackState(),
    loading: true,
  }))

  useEffect(() => {
    let cancelled = false
    setState((current) => ({ ...current, loading: true, error: false }))

    fetchErc721TokenChainData(work.contractAddress, work.tokenId, work.chainId ?? 1)
      .then((tokenData) => {
        if (cancelled) return

        setState({
          ownerAddress: tokenData.ownerAddress,
          tokenURI: tokenData.tokenURI,
          soldCount: tokenData.ownerAddress ? 1 : 0,
          totalCount: 1,
          loading: false,
          error: false,
        })
      })
      .catch(() => {
        if (!cancelled) {
          setState({ ...getFallbackState(), loading: false, error: true })
        }
      })

    return () => {
      cancelled = true
    }
  }, [work.chainId, work.contractAddress, work.tokenId])

  return state
}

export default useMarketplaceWorkChainData
